//Analytics
function sendAddToCartGAEvent(){
    const ADD_TO_CART_BUTTON = document.querySelector(".add-to-cart input.button");
    if (ADD_TO_CART_BUTTON) {

        ADD_TO_CART_BUTTON.addEventListener("click", (e) => {
            return gtag('event', 'conversion', {'send_to': 'AW-760810876/srzSCPiRgpICEPya5OoC'});
        })
    }
}

//Redirects
function redirectTemplateToHomepage(templateName){

    if (templateName == 404){
        return location.pathname = "/"
    }
}



